import { useEffect, useRef } from "react";
import { useGameStore } from "../state/useGameStore";

export function UnlockOverlay() {
  const climaxActive = useGameStore((s) => s.climaxActive);
  const pendingUpgrade = useGameStore((s) => s.pendingUpgrade);
  const dismissClimax = useGameStore((s) => s.dismissClimax);
  const panelRef = useRef(null);
  const continueRef = useRef(null);
  const restoreFocusRef = useRef(null);

  useEffect(() => {
    if (!climaxActive || !pendingUpgrade) return undefined;

    restoreFocusRef.current = document.activeElement;
    const focusContinue = () => continueRef.current?.focus();
    const t = window.setTimeout(focusContinue, 0);

    const onKeyDown = (e) => {
      if (e.key !== "Tab" || !panelRef.current) return;
      const focusable = panelRef.current.querySelectorAll(
        'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const list = Array.from(focusable);
      if (!list.length) return;
      const first = list[0];
      const last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => {
      window.clearTimeout(t);
      document.removeEventListener("keydown", onKeyDown);
      const prev = restoreFocusRef.current;
      if (prev && typeof prev.focus === "function") {
        prev.focus();
      }
    };
  }, [climaxActive, pendingUpgrade]);

  if (!climaxActive || !pendingUpgrade) return null;

  return (
    <div
      className="climax"
      role="dialog"
      aria-modal="true"
      aria-labelledby="climax-title"
      ref={panelRef}
    >
      <button
        type="button"
        className="climax__veil"
        aria-label="Dismiss unlock"
        onClick={dismissClimax}
      />
      <div className="climax__panel">
        <p className="climax__kicker">UNLOCKED</p>
        <h2 id="climax-title" className="climax__title">
          {pendingUpgrade.name}
        </h2>
        <p className="climax__label">{pendingUpgrade.label}</p>
        <p className="climax__blurb">{pendingUpgrade.blurb}</p>
        <button
          type="button"
          className="cta cta--signal"
          onClick={dismissClimax}
          ref={continueRef}
        >
          <span className="cta__label">Continue</span>
          <span className="cta__arrow" aria-hidden="true">
            →
          </span>
        </button>
        <p className="climax__hint">Enter · Space · Esc</p>
      </div>
    </div>
  );
}
